import { httpsCallable } from 'firebase/functions';
import { getFirebaseFunctions } from '../firebase/config';

function getCallable(name) {
  return httpsCallable(getFirebaseFunctions(), name);
}

function base64ToBlob(base64, mimeType = 'application/pdf') {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
}

export function downloadBase64Pdf({ base64, filename }) {
  const blob = base64ToBlob(base64, 'application/pdf');
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'document.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function sendTestEmail(to) {
  const fn = getCallable('sendTestEmail');
  await fn({ to });
}

export async function generateFinanceReportPdf() {
  const fn = getCallable('generateFinanceReport');
  const res = await fn({});
  downloadBase64Pdf(res.data);
  return res.data;
}

export async function generateRecordPdf(type, id) {
  const fn = getCallable('generateRecordPdf');
  const res = await fn({ type, id });
  downloadBase64Pdf(res.data);
  return res.data;
}

export async function sendQuotationToClient(quotationId) {
  const fn = getCallable('sendQuotationToClient');
  const res = await fn({ quotationId });
  return res.data;
}

export async function sendInvoiceToClient(invoiceId) {
  const fn = getCallable('sendInvoiceToClient');
  const res = await fn({ invoiceId });
  return res.data;
}

export async function sendClientEmail({ clientId, subject, text }) {
  const fn = getCallable('sendClientEmail');
  const res = await fn({ clientId, subject, text });
  return res.data;
}

/** Create/update Firebase Auth + users/{uid} and send welcome email for an employee doc. */
export async function provisionEmployeePortal(employeeId, options = {}) {
  const fn = getCallable('provisionEmployeeUser');
  const loginUrl =
    typeof window !== 'undefined' && window.location?.origin
      ? `${window.location.origin}/login`
      : undefined;
  const res = await fn({
    employeeId: String(employeeId),
    loginUrl,
    resendWelcome: !!options.resendWelcome,
  });
  return res.data;
}

/** Remove Auth user and users profile when an employee is deleted (HR / founder). */
export async function deprovisionEmployeePortal(employeeId) {
  const fn = getCallable('deprovisionEmployeeUser');
  const res = await fn({ employeeId: String(employeeId) });
  return res.data;
}

export function formatProvisionResultMessage(result) {
  if (!result?.ok) return 'Portal setup failed.';
  if (result.emailSent) {
    return result.authCreated
      ? 'Portal account created and welcome email sent.'
      : 'Portal account updated and email sent.';
  }
  if (result.tempPassword) {
    return `Portal account created. Mail is not configured — share this temporary password securely: ${result.tempPassword}`;
  }
  if (result.resetLink) {
    return 'Portal account ready. Mail is not configured — share the password-reset link from Cloud Functions logs or Firebase Console.';
  }
  return result.authCreated
    ? 'Portal account created. Configure SMTP on Cloud Functions to send welcome emails automatically.'
    : 'Portal account updated.';
}
